import { useState } from "react";
import { Input } from "antd";
import { MailOutlined, UserOutlined } from '@ant-design/icons';
import Button from "../../../../components/forms/Button";
import "./index.scss";
import { t } from '../../../../utils/i18n';

const CompleteSignup = props => {
    const { userParams, setUserParams } = props;
    const [submitted, setSubmitted] = useState(false);

    const onChange = (key, value) => {
        setUserParams({...userParams, [key]: value})
    }
    const isValid = () => {
        return userParams.firstName.trim().length > 0 && userParams.lastName.trim().length > 0;
    };

    const onSubmit = () => {
        setSubmitted(true);
        if (!isValid()) {
            if (!userParams.firstName.trim()) {
                document.querySelector('#first-name-input').focus();
            } else {
                document.querySelector('#last-name-input').focus();
            }
            return;
        }
        props.onCompleteSignup()
        // onContinue && onContinue({ firstName, lastName });
    };

    return (
        <div className="complete-signup-container">
            <h1>{t('login.complete_profile')}</h1>
            <p className="description">{t('login.enter_full_name')}</p>

            {submitted && !userParams.firstName.trim() && (
                <div className="error-message">
                    <span>{t('login.first_name_required')}</span>
                </div>
            )}
            
            <Input value={props.email} prefix={<MailOutlined />} disabled className="email-input" />

            <Input
                id="first-name-input"
                prefix={<UserOutlined />}
                placeholder={t('login.first_name_placeholder')}
                className={`name-input ${submitted && !userParams.firstName.trim() ? 'invalid' : ''}`}
                value={userParams.firstName}
                onChange={e => onChange('firstName', e.target.value)}
            />

            {submitted && !userParams.lastName.trim() && (
                <div className="error-message">
                    <span>{t('login.last_name_required')}</span>
                </div>
            )}

            <Input
                id="last-name-input"
                prefix={<UserOutlined />}
                placeholder={t('login.last_name_placeholder')}
                className={`name-input ${submitted && !userParams.lastName.trim() ? 'invalid' : ''}`}
                value={userParams.lastName}
                onChange={e => onChange('lastName', e.target.value)}
            />

            <Button type="primary" block className="continue-button" onClick={onSubmit}>
                {t('login.continue')}
            </Button>

            <p className="terms-text">
                {t('login.terms')}
            </p>
        </div>
    );
};

export default CompleteSignup;
